import { CONSTANTS } from '@/common/constants.js';

/**
 * Define a plugin that gives access to constants from the template.
 */
const ConstPlugin = {
	install: function (Vue, options) {
		/**
		 * Gets the constant value. Constants are defined in common/constants.js
		 * @param constName The name of the constant definition.
		 * @param key The name of the constant item.
		 * @example For VALIDATION_SEVERITY_TYPE.ERROR_ pass $getConst('VALIDATION_SEVERITY_TYPE', 'ERROR')
		 */
		Vue.prototype.$getConst = (constName, key) => {
			return CONSTANTS[constName][key];
		};
	}
};

export default ConstPlugin;
